import React from 'react';
import { Button, TextField, Typography, CircularProgress } from '@mui/material';
import type { AuthView } from './types';

interface NewPasswordFormProps {
  code: string;
  setCode: (v: string) => void;
  newPassword: string;
  setNewPassword: (v: string) => void;
  loading: boolean;
  isChallengeReset: boolean;
  handleNewPasswordSubmit: (e: React.SyntheticEvent) => void;
  handleViewChange: (view: AuthView) => void;
}

export const NewPasswordForm: React.FC<NewPasswordFormProps> = ({
  code,
  setCode,
  newPassword,
  setNewPassword,
  loading,
  isChallengeReset,
  handleNewPasswordSubmit,
  handleViewChange,
}) => (
  <form onSubmit={handleNewPasswordSubmit}>
    <Typography variant="body2" sx={{ color: '#555', mb: 2 }}>
      {isChallengeReset
        ? 'Please enter your permanent account password setup below.'
        : 'Please type the numeric code from your inbox along with your new account password configuration.'}
    </Typography>

    {!isChallengeReset && (
      <TextField
        fullWidth
        label="Verification Code"
        variant="outlined"
        margin="normal"
        value={code}
        onChange={(e) => setCode(e.target.value)}
        disabled={loading}
      />
    )}

    <TextField
      fullWidth
      label="New Password"
      type="password"
      variant="outlined"
      margin="normal"
      value={newPassword}
      onChange={(e) => setNewPassword(e.target.value)}
      disabled={loading}
      autoComplete="new-password"
    />
    <Button
      fullWidth
      type="submit"
      variant="contained"
      size="large"
      disabled={loading}
      sx={{ mt: 3, height: 48, backgroundColor: '#FFBC0D', color: '#000', fontWeight: 700, '&:hover': { backgroundColor: '#e5a90c' } }}
    >
      {loading ? <CircularProgress size={24} /> : 'Update Password'}
    </Button>

    <Button
      fullWidth
      type="button"
      variant="text"
      onClick={() => handleViewChange(isChallengeReset ? 'login' : 'forgot')}
      disabled={loading}
      sx={{ mt: 1, color: '#555' }}
    >
      {isChallengeReset ? 'Back to Login' : 'Resend Code'}
    </Button>
  </form>
);
